import { useEffect, useState } from "react";

// Ancho de ventana reactivo para decidir el modo de los paneles del workspace
// (apilado en móvil, superpuesto en escritorio angosto, fijo en escritorio ancho).
export const useWindowWidth = () => {
  const [width, setWidth] = useState(() => (typeof window === "undefined" ? 1280 : window.innerWidth));
  useEffect(() => {
    let raf = null;
    const onResize = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { setWidth(window.innerWidth); raf = null; });
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return width;
};
